import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { SortSelect } from '../sort-select';
import { ProductCard } from '../../../common/product-card';
import { Spinner } from '../../../common/spinner';
import { SearchStore } from '../../../stores/SearchStore';
import iconSystem from './icon-system.svg';
import styles from './ProductList.css';

const IPropTypes = {
  className: PropTypes.string,
};

const defaultProps = {
  className: '',
};

const ProductList = props => (
  <div className={[props.className, styles.container].join(' ')}>
    <h3 className={styles.subtitle}>
      Resultados de Búsqueda
    </h3>
    <h1 className={styles.title}>
      {`"${SearchStore.query || ''}"`}
    </h1>
    {
      SearchStore.error &&
      <div className={styles.message}>
        <img src={iconSystem} alt="" />
        <p>
          <b>
            Error interno
          </b>
        </p>
        <p>
          Estamos enfrentando algunos problemas en este momento, por favor
          inténtalo nuevamente.
        </p>
      </div>
    }
    {
      !SearchStore.filteredProducts &&
      !SearchStore.error &&
      <div>
        <Spinner />
      </div>
    }
    {
      !!SearchStore.filteredProducts &&
      !!SearchStore.filteredProducts.length &&
      <div>
        <div className={styles.sortSection}>
          <p className={styles.genericMessage}>
            {SearchStore.filteredProducts.length} resultado{SearchStore.filteredProducts.length === 1 ? '' : 's'}
          </p>
          <div className={styles.sortContainer}>
            <p className={styles.orderBy}>
              Ordenar por:
            </p>
            <SortSelect />
          </div>
        </div>
        <div className={styles.productContainer}>
          {
            SearchStore.filteredProducts.map(prod => (
              <ProductCard
                className={styles.productCard}
                key={`${prod.id}-${prod.specificId}`}
                product={prod}
              />
            ))
          }
        </div>
      </div>
    }
    {
      !!SearchStore.filteredProducts &&
      SearchStore.filteredProducts.length === 0 &&
      <p className={styles.message}>
        No hay resultados de búsqueda para mostrar. Verifica tu
        búsqueda o intenta con términos más generales.
      </p>
    }
  </div>
);

ProductList.propTypes = IPropTypes;
ProductList.defaultProps = defaultProps;

const ProductListWrapped = observer(ProductList);

export { ProductListWrapped as ProductList };



// WEBPACK FOOTER //
// ./src/pages/search/product-list/ProductList.jsx